import $foreign from "./foreign.cjs";
var fromNumberImpl = $foreign.fromNumberImpl;
var fromStringAsImpl = $foreign.fromStringAsImpl;
var pow = $foreign.pow;
var quot = $foreign.quot;
var rem = $foreign.rem;
var toNumber = $foreign.toNumber;
var toStringAs = $foreign.toStringAs;
export { fromNumberImpl, fromStringAsImpl, pow, quot, rem, toNumber, toStringAs };
